// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-SongRow-module__songDescription-qYogH {
  width: 100%;
  gap: 16px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  overflow: hidden;
}

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__dragHandle-x3zYf {
    display: grid;
    align-items: center;
    justify-items: center;
    place-items: center;
    height: 20px;
    width: 20px;
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__draggableHandle-SMCom {
    display: none;
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__dragHandleIcon-C_3fC {
    display: none;
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__positionBadge-_Wm3e {
    display: block;
    --badge-padding-x: 4px;
    background-color: var(--background-tertiary);
    color: var(--text-primary);
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__songInfo-Q2PIs {
    display: flex;
    flex: 1 1 0;
    width: 0;
    flex-direction: column;
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__songDescriptionText-bZVGU {
    color: var(--text-secondary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

.nightbot-SongRow-module__songDescription-qYogH .nightbot-SongRow-module__songTitle-u2D_B {
    cursor: pointer;
    white-space: nowrap;
    color: var(--text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

.nightbot-SongRow-module__draggable-TMs_v {
  cursor: grab;
}

.nightbot-SongRow-module__songDescription-qYogH:hover .nightbot-SongRow-module__dragHandleIcon-C_3fC {
    display: block;
    color: var(--text-secondary);
  }

.nightbot-SongRow-module__songDescription-qYogH:hover .nightbot-SongRow-module__positionBadge-_Wm3e {
    display: none;
  }

.nightbot-SongRow-module__songDescriptionColumn-A66TO {
  max-width: 1px;
}

.nightbot-SongRow-module__draggingSong-ouKzr {
  max-width: 600px;
  padding: 16px 20px;
  background-color: var(--background-active);
  border-radius: var(--mantine-radius-md);
  box-shadow: var(--mantine-shadow-outline);
}

.nightbot-SongRow-module__draggingSong-ouKzr .nightbot-SongRow-module__songTitle-u2D_B {
    color: var(--text-active);
  }

.nightbot-SongRow-module__draggingSong-ouKzr .nightbot-SongRow-module__songDescriptionText-bZVGU {
    color: var(--text-active-secondary);
  }

.nightbot-SongRow-module__draggingSong-ouKzr .nightbot-SongRow-module__positionBadge-_Wm3e {
    background-color: var(--background-active-secondary);
    color: var(--text-active);
  }

.nightbot-SongRow-module__actionsColumn-Q3kCU {
  text-align: right;
  width: 1px;
}

.nightbot-SongRow-module__requesterContainer-xkGqh {
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: right;
  text-align: right;
  white-space: nowrap;
}

.nightbot-SongRow-module__requesterContainer-xkGqh .nightbot-SongRow-module__createdAt-EMce4 {
    color: var(--text-secondary);
  }

.nightbot-SongRow-module__requesterColumn-t28_c {
  width: 1px;
}

`, "",{"version":3,"sources":["webpack://./src/components/song_requests/SongRow.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,SAAS;EACT,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AA8ClB;;AA5CE;IACE,aAAa;IACb,mBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,cAAc;IACd,sBAAsB;IACtB,4CAA4C;IAC5C,0BAA0B;EAC5B;;AAEA;IACE,aAAa;IACb,WAAW;IACX,QAAQ;IACR,sBAAsB;EACxB;;AAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;AAEA;IACE,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;AAGF;EACE,YAAY;AACd;;AAGE;IACE,cAAc;IACd,4BAA4B;EAC9B;;AAEA;IACE,aAAa;EACf;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;EACvC,yCAAyC;AAc3C;;AAZE;IACE,yBAAyB;EAC3B;;AAEA;IACE,mCAAmC;EACrC;;AAEA;IACE,oDAAoD;IACpD,yBAAyB;EAC3B;;AAGF;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AAKrB;;AAHE;IACE,4BAA4B;EAC9B;;AAGF;EACE,UAAU;AACZ","sourcesContent":[".songDescription {\n  width: 100%;\n  gap: 16px;\n  user-select: none;\n  align-items: center;\n  display: inline-flex;\n  flex-direction: row;\n  overflow: hidden;\n\n  .dragHandle {\n    display: grid;\n    place-items: center;\n    height: 20px;\n    width: 20px;\n  }\n\n  .draggableHandle {\n    display: none;\n  }\n\n  .dragHandleIcon {\n    display: none;\n  }\n\n  .positionBadge {\n    display: block;\n    --badge-padding-x: 4px;\n    background-color: var(--background-tertiary);\n    color: var(--text-primary);\n  }\n\n  .songInfo {\n    display: flex;\n    flex: 1 1 0;\n    width: 0;\n    flex-direction: column;\n  }\n\n  .songDescriptionText {\n    color: var(--text-secondary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .songTitle {\n    cursor: pointer;\n    white-space: nowrap;\n    color: var(--text-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.draggable {\n  cursor: grab;\n}\n\n.songDescription:hover {\n  .dragHandleIcon {\n    display: block;\n    color: var(--text-secondary);\n  }\n\n  .positionBadge {\n    display: none;\n  }\n}\n\n.songDescriptionColumn {\n  max-width: 1px;\n}\n\n.draggingSong {\n  max-width: 600px;\n  padding: 16px 20px;\n  background-color: var(--background-active);\n  border-radius: var(--mantine-radius-md);\n  box-shadow: var(--mantine-shadow-outline);\n\n  .songTitle {\n    color: var(--text-active);\n  }\n\n  .songDescriptionText {\n    color: var(--text-active-secondary);\n  }\n\n  .positionBadge {\n    background-color: var(--background-active-secondary);\n    color: var(--text-active);\n  }\n}\n\n.actionsColumn {\n  text-align: right;\n  width: 1px;\n}\n\n.requesterContainer {\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  align-items: right;\n  text-align: right;\n  white-space: nowrap;\n\n  .createdAt {\n    color: var(--text-secondary);\n  }\n}\n\n.requesterColumn {\n  width: 1px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"songDescription": `nightbot-SongRow-module__songDescription-qYogH`,
	"dragHandle": `nightbot-SongRow-module__dragHandle-x3zYf`,
	"draggableHandle": `nightbot-SongRow-module__draggableHandle-SMCom`,
	"dragHandleIcon": `nightbot-SongRow-module__dragHandleIcon-C_3fC`,
	"positionBadge": `nightbot-SongRow-module__positionBadge-_Wm3e`,
	"songInfo": `nightbot-SongRow-module__songInfo-Q2PIs`,
	"songDescriptionText": `nightbot-SongRow-module__songDescriptionText-bZVGU`,
	"songTitle": `nightbot-SongRow-module__songTitle-u2D_B`,
	"draggable": `nightbot-SongRow-module__draggable-TMs_v`,
	"songDescriptionColumn": `nightbot-SongRow-module__songDescriptionColumn-A66TO`,
	"draggingSong": `nightbot-SongRow-module__draggingSong-ouKzr`,
	"actionsColumn": `nightbot-SongRow-module__actionsColumn-Q3kCU`,
	"requesterContainer": `nightbot-SongRow-module__requesterContainer-xkGqh`,
	"createdAt": `nightbot-SongRow-module__createdAt-EMce4`,
	"requesterColumn": `nightbot-SongRow-module__requesterColumn-t28_c`
};
export default ___CSS_LOADER_EXPORT___;
